module.exports = __webpack_public_path__ + "static/media/electrical.75a3e617.svg";